import { type IClientWebhook } from "@gen/app-query";
import * as z from "zod";

export const clientWebhookSchema = z.object({
  id: z.string(),

  client_id: z.string(),

  username: z
    .string({
      error: (issue) => {
        if (issue.input === undefined) {
          return "Please enter a Username";
        }
      },
    })
    .min(1, {
      error: (issue) => {
        if (issue.code === "too_small") {
          return "Please enter a Username";
        }
      },
    }),

  password: z
    .string({
      error: (issue) => {
        if (issue.input === undefined) {
          return "Please enter a Password";
        }
      },
    })
    .min(1, {
      error: (issue) => {
        if (issue.code === "too_small") {
          return "Please enter a Password";
        }
      },
    }),

  url: z.url({
    error: (issue) => {
      if (issue.input === undefined) {
        return "Please enter a URL";
      }
      return "Please enter a valid URL";
    },
  }),

  created: z.date(),

  updated: z.date(),
}) satisfies z.ZodType<IClientWebhook>;
